import parsePhoneNumberFromString, { CountryCode } from "libphonenumber-js";

// Extract is set to false to prevent the function from accepting letters in the phone number
export const validatePhoneNumber = ({
  phoneNumber,
  countryCode = "NL",
}: {
  phoneNumber: string;
  countryCode?: CountryCode;
}) => {
  if (typeof phoneNumber !== "string") return false; // Runtime check
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode);
  return parsedNumber ? parsedNumber.isValid() : false;
};

//TODO: Check if the replace method is necessary
export const formatPhoneNumber = ({
  phoneNumber,
  countryCode = "NL",
}: {
  phoneNumber: string;
  countryCode?: CountryCode;
}) => {
  if (phoneNumber === "") return null;
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode);
  return parsedNumber
    ? parsedNumber.format("E.164").replace(/\s+/g, "")
    : phoneNumber;
};

export const parsePhoneNumber = ({
  phoneNumber,
  countryCode = "NL",
}: {
  phoneNumber: string;
  countryCode?: CountryCode;
}) => {
  if (phoneNumber === "") return null;
  return parsePhoneNumberFromString(phoneNumber, countryCode);
};
